import {Component, ViewChild} from '@angular/core';
import {Events, IonicPage, NavController, NavParams, Refresher} from 'ionic-angular';
import {PaymentNewCardPage} from "../payment-new-card/payment-new-card";
import {HttpClient} from "@angular/common/http";
import {StripeServiceProvider} from "../../providers/stripe-service/stripe-service";

@IonicPage()
@Component({
  selector: 'page-payment-methods',
  templateUrl: 'payment-methods.html',
})
export class PaymentMethodsPage {

  public loading: boolean = true;
  public paymentMethods;
  public showBanner: boolean;
  public defaultPaymentMethod: any;

  @ViewChild(Refresher) refresher: Refresher;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public http: HttpClient,
    public stripeService: StripeServiceProvider,
    public events: Events
  ) {
    this.showBanner = false;
    this.paymentMethods = null;

    events.subscribe('stripe:paymentMethodSaved', (paymentMethod) => {
      this.paymentMethods.push(paymentMethod);
      this.showBanner = true;

      setTimeout(() => {
        this.showBanner = false;
      }, 3000)
    });
  }

  ionViewDidLoad() {
  }

  ionViewDidEnter() {
    this.loading = true;
    this.stripeService.getPaymentMethods().then((methods: any) => {
      this.paymentMethods = methods.data;
      this.loading = false;
    }).catch(error => {
      this.loading = false;
    })
  }

  deletePaymentMethod(paymentMethodId) {
    this.loading = true;
    this.stripeService.getCustomer().then((customer: any) => {
      this.defaultPaymentMethod = customer.invoice_settings.default_payment_method;

      this.stripeService.detachPaymentMethod(paymentMethodId).then((detachedMethod: any) => {

        // Set a new default payment method if the default is removed
        if (this.defaultPaymentMethod === paymentMethodId && this.paymentMethods.length > 0) {
          this.removeDeletedPaymentMethod(detachedMethod).then(() => {
            this.stripeService.changePaymentMethod(this.paymentMethods[0].    id).then(() => {
              this.loading = false;
            });
          }).catch(error => {
            this.loading = false;
          })
        } else {
          this.removeDeletedPaymentMethod(detachedMethod).then(() => {
            this.loading = false;
          })
        }
      })
    });
  }

  removeDeletedPaymentMethod(detachedMethod) {
    return new Promise((resolve) => {
      this.paymentMethods.forEach((item, index) => {
        if (item.id === detachedMethod.id) {
          this.paymentMethods.splice(index, 1);
          resolve(this.paymentMethods);
        }
      });
    });
  }

  openPaymentNewCardPage() {
    this.navCtrl.push(PaymentNewCardPage);
  }

  pullToRefresh() {
    this.stripeService.getPaymentMethods().then((methods: any) => {
      this.paymentMethods = methods.data;
      this.refresher.complete();
    }).catch(error => {
      this.refresher.complete();
    });
  }
}




// WEBPACK FOOTER //
// ./src/pages/payment-methods/payment-methods.ts